<template>
	<el-container id="test" v-loading="test_load">
		<div class="location">
			<p>当前位置：</p>
			<p class="item" v-for="(item,index) in page_location" :key="index" @click="jumpPage(item)">{{item.title}} &gt;</p>
			{{test_tit}}
		</div>
		<div class="testCon" v-if="!done_exam_result" v-loading="done_exam_load">
			<div class="test_tit">
				<h1 class="titCon">{{test_tit}}</h1>
				<div class="count">
					<p class="time"><font v-if="test_time">本次考试限时{{test_time}}分钟，</font>共{{test_exam}}道题，满分为{{test_fen}}分</p>
				</div>
			</div>
			<el-form :model="testForm">
				<div class="big_question" v-for="(item,index) in formal" :key="index" v-if="item.list && item.list.length >= 1">
					<div class="big_qs_tit">
						<font class="qiZh">{{$selfjs.qiZh(index+1)}}、</font>
						<font class="headline">{{item.headline == "" ? big_qs_tit_txt(key) : item.headline}}</font>
						<font class="big_qs_count">（共{{item.list.length}}题）</font>
					</div>
					<ul :class="item.type" v-if="item.type=='single'">
						<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
							<p><font>{{(ti_index+1)}}.</font><span class="title" v-html="tiObj.title.replace(/\n/g, '<br>')"></span><span class="score">（{{tiObj.score}}分）</span></p>
							<p v-if="tiObj.question_img" class="question_img">
								<img :src="ali_oss+tiObj.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+tiObj.question_img})"></p>
							<dl>
								<el-form-item v-if="testForm[item.type].length>0" v-for="(chObj,ch_index) in tiObj.choices" :key="ch_index">
									<el-radio-group v-model="testForm.single[ti_index].answer[0]">
										<el-radio :label="chObj.flag">
											<!-- {{chObj.flag+'. '+chObj.content}} -->
											{{chObj.flag}}.
											<img v-if="chObj.img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+chObj.img})" :src="ali_oss+chObj.img">
											 {{chObj.content}}
										</el-radio>
									</el-radio-group>
								</el-form-item>
							</dl>
						</li>
					</ul>
					<ul :class="item.type" v-if="item.type=='multiple'">
						<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
							<p><font>{{(ti_index+1)}}.</font><span class="title" v-html="tiObj.title.replace(/\n/g, '<br>')"></span><span class="score">（{{tiObj.score}}分）</span></p>
							<p v-if="tiObj.question_img" class="question_img"><img :src="ali_oss+tiObj.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+tiObj.question_img})"></p>
							<dl>
								<el-form-item>
									<el-checkbox-group v-if="testForm[item.type].length>0" v-model="testForm.multiple[ti_index].answer">
										<el-checkbox v-for="(chObj,ch_index) in tiObj.choices" :key="ch_index" :label="chObj.flag" :name="key+ti_index+ch_index">
											<!-- {{chObj.flag+'. '+chObj.content}} -->
											{{chObj.flag}}.
											<img v-if="chObj.img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+chObj.img})" :src="ali_oss+chObj.img">
											{{chObj.content}}
										</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</dl>
						</li>
					</ul>
					<ul :class="item.type" v-if="item.type=='judgement'">
						<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
							<p><font>{{(ti_index+1)}}.</font><span class="title" v-html="tiObj.title.replace(/\n/g, '<br>')"></span><span class="score">（{{tiObj.score}}分）</span></p>
							<p v-if="tiObj.question_img" class="question_img"><img :src="ali_oss+tiObj.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+tiObj.question_img})"></p>
							<dl>
								<el-form-item>
									<el-radio-group v-if="testForm[item.type].length>0" v-model="testForm.judgement[ti_index].answer[0]">
										<el-radio label="对"></el-radio>
										<el-radio label="错"></el-radio>
									</el-radio-group>
								</el-form-item>
							</dl>
						</li>
					</ul>
					<ul :class="item.type" v-if="item.type=='fill' || item.type=='other1' || item.type=='other2'">
						<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
							<p><font>{{(ti_index+1)}}.</font><span class="title" v-html="tiObj.title.replace(/\n/g, '<br>')"></span><span class="score">（{{tiObj.score}}分）</span></p>
							<p v-if="tiObj.question_img" class="question_img"><img :src="ali_oss+tiObj.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+tiObj.question_img})"></p>
							<dl>
								<!-- 输入框显示 -->
								<div class="input_box">
									<el-form-item :style="item.type!='fill'?'width: 100%;':''"  v-for="ch_index in tiObj.fill_count" :key="ch_index" v-if="testForm[item.type].length>0">
										<el-input :type="item.type!='fill'?'textarea':'text'" v-model="testForm[item.type][ti_index].answer[ch_index-1]" autocomplete="off"></el-input>
									</el-form-item>
								</div>
								<!-- 图片选择 -->
								<div class="upload_box">
									<el-upload v-if="testForm[item.type].length>0" class="upload_item" action="#" list-type="picture-card" :auto-upload="false" :limit='5'
									:on-change="handle_change"
									:on-exceed="handle_exceed"
									:file-list="testForm[item.type][ti_index].answer_img">
										<i slot="default" @click="handProgress(item.type, ti_index)" class="el-icon-plus"></i>
										<div slot="file" slot-scope="{file}">
											<img class="el-upload-list__item-thumbnail" :src="file.url" alt />
											<div class="el-upload-list__item-actions">
												<span @click="handlePictureCardPreview(file)">
													<i class="el-icon-zoom-in"></i>
												</span>
												<span @click="handleRemove(file, item.type, ti_index)">
													<i class="el-icon-delete"></i>
												</span>
											</div>
										</div>
									</el-upload>
									<p class="upload_desc">只能上传jpg/jpeg/png文件，且不超过500kb</p>
								</div>
							</dl>
						</li>
					</ul>
					<ul :class="item.type" v-if="item.type=='open'">
						<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
							<p><font>{{(ti_index+1)}}.</font><span class="title" v-html="tiObj.title.replace(/\n/g, '<br>')"></span><span class="score">（{{tiObj.score}}分）</span></p>
							<p v-if="tiObj.question_img" class="question_img"><img :src="ali_oss+tiObj.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+tiObj.question_img})"></p>
							<dl>
								<div class="input_box">
									<el-form-item v-for="ch_index in tiObj.fill_count" :key="ch_index" v-if="testForm[item.type].length>0">
										<el-input type="textarea" class="open_textarea" v-model="testForm.open[ti_index].answer[0]" autocomplete="off"></el-input>
									</el-form-item>
								</div>
								<!-- 图片选择 -->
								<div class="upload_box" v-if="temp.open.up_img">
									<el-upload v-if="testForm[item.type].length>0" class="upload_item" action="#" list-type="picture-card" :auto-upload="false" :limit='5'
									:on-change="handle_change"
									:on-exceed="handle_exceed"
									:file-list="testForm[item.type][ti_index].answer_img">
										<i slot="default" @click="handProgress(item.type, ti_index)" class="el-icon-plus"></i>
										<div slot="file" slot-scope="{file}">
											<img class="el-upload-list__item-thumbnail" :src="file.url" alt />
											<div class="el-upload-list__item-actions">
												<span @click="handlePictureCardPreview(file)">
													<i class="el-icon-zoom-in"></i>
												</span>
												<span @click="handleRemove(file, item.type, ti_index)">
													<i class="el-icon-delete"></i>
												</span>
											</div>
										</div>
									</el-upload>
									<p class="upload_desc">只能上传jpg/jpeg/png文件，且不超过500kb</p>
								</div>
							</dl>
						</li>
					</ul>
					<div v-if="item.type=='universal'" v-for="(universal_item,universal_index) in item.list" :key="universal_index+'sub'+index">
						<!-- <div class="big_qs_tit" v-if="index == 0">
							<font class="headline">{{formal.universal.headline == "" ? big_qs_tit_txt('universal') : formal.universal.headline}}</font>
						</div> -->
						<div class="universal_item_headline">{{universal_item.headline}}</div>
						<div class="universal_item_title" v-html="universal_item.title"></div>
						<div v-for="(children_item,sub_i) in universal_item.children" :key="children_item.id+'sub'+sub_i">
							<ul :class="children_item.type" v-if="children_item.type=='single'">
								<li :class="'universal'+children_item.unive_i+sub_i">
									<p><font>{{(children_item.universal_sort)}}.</font><span class="title" v-html="children_item.title.replace(/\n/g, '<br>')"></span><span class="score">（{{children_item.score}}分）</span></p>
									<p v-if="children_item.question_img" class="question_img">
										<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
									</p>
									<dl>
										<!-- {{children_item.unive_i}}
										{{testForm_universal[children_item.unive_i]}}
										{{children_item.id}} -->
										<el-form-item v-for="(chObj,ch_index) in children_item.choices" :key="ch_index">
											<el-radio-group v-model="testForm_universal[children_item.unive_i][children_item.id].answer[0]">
												<el-radio :label="chObj.flag">
													{{chObj.flag}}.
													<img v-if="chObj.img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+chObj.img})" :src="ali_oss+chObj.img">
													 {{chObj.content}}
												</el-radio>
											</el-radio-group>
										</el-form-item>
									</dl>
								</li>
							</ul>
							<ul :class="children_item.type" v-if="children_item.type=='multiple'">
								<li :class="'universal'+children_item.unive_i+sub_i">
									<p><font>{{(children_item.universal_sort)}}.</font><span class="title" v-html="children_item.title.replace(/\n/g, '<br>')"></span><span class="score">（{{children_item.score}}分）</span></p>
									<p v-if="children_item.question_img" class="question_img">
										<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
									</p>
									<dl>
										<el-form-item>
											<el-checkbox-group v-if="children_item.choices.length>0" v-model="testForm_universal[children_item.unive_i][children_item.id].answer">
												<el-checkbox v-for="(chObj,ch_index) in children_item.choices" :key="ch_index" :label="chObj.flag" :name="children_item.unive_i+'cho'+ch_index">
													<!-- {{chObj.flag+'. '+chObj.content}} -->
													{{chObj.flag}}.
													<img v-if="chObj.img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+chObj.img})" :src="ali_oss+chObj.img">
													{{chObj.content}}
												</el-checkbox>
											</el-checkbox-group>
										</el-form-item>
									</dl>
								</li>
							</ul>
							<ul :class="children_item.type" v-if="children_item.type=='judgement'">
								<li :class="'universal'+children_item.unive_i+sub_i">
									<p><font>{{(children_item.universal_sort)}}.</font><span class="title" v-html="children_item.title.replace(/\n/g, '<br>')"></span><span class="score">（{{children_item.score}}分）</span></p>
									<p v-if="children_item.question_img" class="question_img">
										<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
									</p>
									<dl>
										<el-form-item>
											<el-radio-group v-model="testForm_universal[children_item.unive_i][children_item.id].answer[0]">
												<el-radio label="对"></el-radio>
												<el-radio label="错"></el-radio>
											</el-radio-group>
										</el-form-item>
									</dl>
								</li>
							</ul>
							<ul :class="children_item.type" v-if="children_item.type=='fill'">
								<li :class="'universal'+children_item.unive_i+sub_i">
									<p><font>{{(children_item.universal_sort)}}.</font><span class="title" v-html="children_item.title.replace(/\n/g, '<br>')"></span><span class="score">（{{children_item.score}}分）</span></p>
									<p v-if="children_item.question_img" class="question_img">
										<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
									</p>
									<dl>
										<!-- 输入框显示 -->
										<div class="input_box">
											<el-form-item v-for="(ch_item,ch_index) in children_item.choices" :key="ch_index+'ch'">
												<el-input v-model="testForm_universal[children_item.unive_i][children_item.id].answer[ch_index]" autocomplete="off"></el-input>
											</el-form-item>
										</div>
										<!-- 图片选择 -->
										<div class="upload_box">
											<el-upload class="upload_item" action="#" list-type="picture-card" :auto-upload="false" :limit='5'
											:on-change="u_handle_change"
											:on-exceed="handle_exceed"
											:file-list="testForm_universal[children_item.unive_i][children_item.id].answer_img">
												<i slot="default" @click="handProgress(children_item.unive_i, children_item.id)" class="el-icon-plus"></i>
												<div slot="file" slot-scope="{file}">
													<img class="el-upload-list__item-thumbnail" :src="file.url" alt />
													<div class="el-upload-list__item-actions">
														<span @click="handlePictureCardPreview(file)">
															<i class="el-icon-zoom-in"></i>
														</span>
														<span @click="u_handleRemove(file, children_item.unive_i, children_item.id)">
															<i class="el-icon-delete"></i>
														</span>
													</div>
												</div>
											</el-upload>
											<p class="upload_desc">只能上传jpg/jpeg/png文件，且不超过500kb</p>
										</div> 
									</dl>
								</li>
							</ul>
							<ul :class="children_item.type" v-if="children_item.type=='open'">
								<li :class="'universal'+children_item.unive_i+sub_i">
									<p><font>{{(children_item.universal_sort)}}.</font><span class="title" v-html="children_item.title.replace(/\n/g, '<br>')"></span><span class="score">（{{children_item.score}}分）</span></p>
									<p v-if="children_item.question_img" class="question_img">
										<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
									</p>
									<dl>
										
										<div class="input_box">
											<el-form-item>
												<el-input type="textarea" class="open_textarea" v-model="testForm_universal[children_item.unive_i][children_item.id].answer[0]" autocomplete="off"></el-input>
											</el-form-item>
										</div>
										<!-- 图片选择 -->
										<div class="upload_box" v-if="temp.universal.open.up_img">
											<el-upload class="upload_item" action="#" list-type="picture-card" :auto-upload="false" :limit='5'
											:on-change="u_handle_change"
											:on-exceed="handle_exceed"
											:file-list="testForm_universal[children_item.unive_i][children_item.id].answer_img">
												<i slot="default" @click="handProgress(children_item.unive_i, children_item.id)" class="el-icon-plus"></i>
												<div slot="file" slot-scope="{file}">
													<img class="el-upload-list__item-thumbnail" :src="file.url" alt />
													<div class="el-upload-list__item-actions">
														<span @click="handlePictureCardPreview(file)">
															<i class="el-icon-zoom-in"></i>
														</span>
														<span @click="u_handleRemove(file, children_item.unive_i, children_item.id)">
															<i class="el-icon-delete"></i>
														</span>
													</div>
												</div>
											</el-upload>
											<p class="upload_desc">只能上传jpg/jpeg/png文件，且不超过500kb</p>
										</div>
									</dl>
								</li>
							</ul>
						</div>
						
					</div>
				</div>
				<el-button type="primary" @click="submitForm('testForm')"><i class="iconfont">&#xe651;</i>提交</el-button>
			</el-form>
		</div>
		<div v-if="done_exam_result" class="exerciseCon">
			<div class="title_box">
				{{test_tit}}
				<span>
					<i class="iconfont">&#xe6ea;</i>
					题数：{{test_exam}}
				</span>
			</div>
			<div class="result_con">
				<h3 class="deliver">交卷时间：{{done_exam.time}}</h3>
				<div class="progress_box">
					<el-progress :stroke-width='10' :show-text="false" :width="150" type="circle" :percentage="done_exam.percentage" :color="colors"></el-progress>
					<div class="score">
						<h1>{{done_exam.sys_score}}<font>分</font></h1>
						<span>计分题{{test_exam}}道</span>
					</div>
				</div>
				<div class="res_info">
					共{{test_exam}}题，答对{{done_exam.right_num}}道，答错{{done_exam.wrong_num}}道<br>
					总用时{{done_exam.total_time}}
				</div>
			</div>
			<div class="btn_box">
				<div class="error_btn" @click="test_err('error')"><i class="iconfont">&#xe61a;</i>错题解析</div>
				<div class="all_btn" @click="test_err('all')"><i class="iconfont">&#xe61a;</i>全部解析</div>
				<div class="again_btn" @click="test_again"><i class="iconfont">&#xe7db;</i>再测一次</div>
			</div>
		</div>
		<div class="timeCalculationBox" v-if="!done_exam_result">
			<div class="camera_outer" v-if="join_kaoshi.is_photograph || join_kaoshi.is_inspection">
				<video v-if="camera" ref="mediaElement" id="videoCamera" autoplay style="width:100%"></video>
				<canvas v-if="camera" style="display:none;" id="canvasCamera"></canvas>
      			<div class="img_bg_camera" style="display:none;">
      			  	<img :src="imgSrc" alt="" class="tx_img">
      			</div>
			</div>
			<div class="timeBox"><i class="iconfont">&#xe6b1;</i>{{timeCal}}</div>
			<div class="timu_scroll">
				<ul>
					<li v-for="(item,index) in formal" :key="index" v-if="item.list && item.list.length >= 1">
						<div v-if="item.type != 'universal'">
							<h2>{{item.headline == "" ? big_qs_tit_txt(item.type) : item.headline}}</h2>
							<dl>
								<dd v-for="(obj,numindex) in testForm[item.type]" :class="time_cal_class(obj)" :key="numindex" @click="scrollFn(item.type+index+numindex)">{{numindex+1}}</dd>
							</dl>
						</div>
						<div v-else style="margin-top:10px;">
							<h2>{{item.headline == "" ? big_qs_tit_txt('universal') : item.headline}}</h2>
							<dl v-for="(un,un_idx) in item.list" :key="un_idx">
								<dd v-for="(un_obj, un_obj_idx) in un.children" :key="un_obj_idx" :class="time_cal_class(un_obj,'universal')" @click="scrollFn(testForm_universal[un_obj.unive_i][un_obj.id].click_str)">
									{{un_obj.universal_sort}}
								</dd>
							</dl>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<el-dialog
			title="提示"
			:visible.sync="dialogVisible"
			width="30%">
			<span>当前正在考试，是否离开</span>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="pageout">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog
			class="question_preview"
			title=""
			width="intial"
			:visible.sync="question_preview_visible" center>
			<span slot="footer" class="dialog-footer"><img :src="preview_img_src"></span>
		</el-dialog>
	</el-container>
</template>

<script>
// import { log } from 'util';
var tnum
let token, serverSrc, qianzui, question_info
const OSS = require('ali-oss');
// let client = new OSS({
// 	secure:true,
// 	region: 'oss-cn-shenzhen',
// 	accessKeyId: 'LTAI5t9WQNcsH2e7W5Nr78HL',
// 	accessKeySecret: '4FIy6qj1dSDhGy521AxKKkpdcssUYm',
// 	bucket: 'study-ol-oss',
// });
export default {
	inject: ['reload'],		//注入reload方法
	name: 'test'
	,data () {
		tnum=0;
		let formal={
			single:{	 //单选题
				list: [],
			},
			multiple:{		//多选题
				list:[],
			},
			judgement:{		//判断题
				list:[],
			},
			fill:{		//填空题
				list:[],
			},
			open:{		//主观题
				list:[],
			},
			universal:{ //大题
				list:[
				// 	{ 
				// 	choices: [],
				// 	correct_answer: "",
				// 	fill_count: 0,
				// 	id: '',
				// 	question_img: "",
				// 	score: 0,
				// 	children:[],
				// 	title:'大题'
				// }
				]
			},
		}

		return {
			temp: this.temp.course_info.exercise,
			// client:new OSS(this.global.new_oss),
			time_cal_show:false,
			// 交卷防止多次
			done_exam_load:false,
			//拍摄
			join_kaoshi:this.global.join_kaoshi,	//是否渲染拍摄
			imgSrc: '',
        	thisCancas: null,
        	thisContext: null,
        	thisVideo: null,
			camera:true,
			//拍照计时
			photo_time:0,

			// 页面参数
			ali_oss:this.global.oss_link,
			test_load:true,
			page_location:[],
			location:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
			},{
				title:"我的课程",
				router:"/web/courseInfo/",
				name: 'courseInfo',
				activeIndex: 'index',
				query:{courseId:this.$route.query.courseId}
			},{
				title:"题库练习",
				router:"/web/courseInfo/",
				name: 'courseInfo',
				activeIndex: 'index',
				query:{
					courseId:this.$route.query.courseId,
					menuBox:'tiku',
				}
			}],
			location2:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
			},{
				title:"我的作业",
				router:"/web/zuoye/",
				name: 'zuoye',
				activeIndex: 'zuoye'
			}],
			//文件上传
			question_preview_visible:false,
			preview_img_src:'',
			upload_img_info:{
				key:'',
				ti_index:'',
			},

			//试题
			test_tit:'',
			test_time:0,
			test_fen:0,
			test_exam:0,
			testForm:{
				single:[],
				multiple:[],
				judgement:[],
				fill:[],
				open:[],
				other1:[],
				other2:[],
				universal:[]
			},
			testForm_universal:[],
			formal:formal,
			timeCal:"0:00:00",
			//结果
			done_exam_result:false,
			done_exam:{
				time:'2021年8月18日 15：30',
				sys_score:0,
				percentage:0,
				right_num:0,
				wrong_num:0,
				total_time:'1小时5分28秒',
			},
			colors: [
				{color: '#f56c6c', percentage: 20},
				{color: '#e6a23c', percentage: 40},
				{color: '#5cb87a', percentage: 60},
				{color: '#1989fa', percentage: 80},
				{color: '#5777fe', percentage: 100}
			],

			//页面离开
			tijiaolikai:false,
			dialogVisible:false,
			beforeRouteLeave_next:'',
			leave_type:'',
			//大题排序
			universal_sort:0,
			universal_sort_arr:[]
		}
	}
	,mounted:function(){
		var that=this
		token=this.$cookies.get("token")
		serverSrc=that.global.serverSrc
		qianzui=that.global.qianzui
		question_info
		let type = this.$route.query.type

		// 判断使用哪个位置
		if(type == "exercises"){
			this.page_location = this.location2
			// this.test_load = false
		}else{
			this.page_location = this.location
		}
		//判断是否从考试安排页进入
		// if(!this.join_kaoshi.switch){
		// 	this.$alert('请从考试安排进入考试页', '提示', {
		// 		confirmButtonText: '确定',
		// 		closeOnHashChange: false,
		// 		showClose: false,
		// 		callback: action => {
		// 			this.back_courseInfo()
		// 		}
		// 	});
		// 	return false;
		// }
		
		//修改上一页的网址
		history.pushState(null, null, document.URL);
    	window.addEventListener('popstate', function () {
			if(!that.dialogVisible){
				//修改切换页面的类型
				that.leave_type = 'popstate'
				//显示询问返回的弹窗
				that.dialogVisible = true
				//修改上一页的网址
				history.pushState(null, null, document.URL);
			}
    	});
		//获取试题信息
		let url = serverSrc + qianzui
			,get_data = {}
		if(type == 'simulation' || type == 'real' || type == 'exercises'){
			url += "/exercises/" + this.$route.query.type_id
		}else if(type == 'video' || type == 'chapter'){
			url += "/exercises/sectionDetail"
			get_data = {
				section_id: this.$route.query.type_id,
				type: this.$route.query.type
			}
		}
		// 获取试题
		this.$ajax.get(url,{
			params: get_data
		})
		.then((res)=>{
			let resData=res.data
			if(resData.code==0){
				let unive_i = 0
				question_info = resData.data

				document.title = question_info.title + '题库练习' + that.$store.state.titleAfter			//动态设置标题

				that.done_start_time = new Date().getTime()		//练习开始时间
				that.test_load = false
				that.test_tit = question_info.title
				that.test_time = question_info.duration			// 考试限时时间，单位：分钟
				that.timeTotal = that.test_time * 60
				that.test_fen = question_info.max_score
				that.test_exam = question_info.question_total
				that.formal = question_info.question
				for (let i = 0; i < question_info.question.length; i++) {
					let tiNnum=question_info.question[i].list.length,
						tiArr=[],
						key = question_info.question[i].type,
							data_obj = question_info.question[i]
						for(let t=0;t<tiNnum;t++){
						let tiId = data_obj.list[t].id,
							tianArr = [],
								tianImgArr = []
							if(key == "fill" || key == "other1" || key == "other2"){
								for(let f=0;f<data_obj.list[t].fill_count;f++){
									tianArr.push("")
								}
							}
							tiArr.push({"question_id":tiId, "answer":tianArr, "answer_img": tianImgArr})
					}
					this.testForm[key] = tiArr
					if (key == 'universal') {
						for (let j = 0; j < data_obj.list.length; j++) {
							let uni_obj = data_obj.list[j]
							let obj = {}
							// console.log(j);
							// console.log(uni_obj);
							this.universal_sort = 0
							for (let l = 0; l < uni_obj.children.length; l++) {
								this.universal_sort++
								uni_obj.children[l].universal_sort = this.universal_sort
								uni_obj.children[l].unive_i = unive_i
								let tiId = uni_obj.children[l].id,
									key = uni_obj.children[l].type,
									tianArr = [],
									tianImgArr = []
								if(key == "fill" || key == "other1" || key == "other2"){
									for(let f=0;f<uni_obj.children[l].choices.length;f++){
										tianArr.push("")
									}
								}
								obj[tiId] = {
									question_id: tiId,
									answer: tianArr,
									answer_img: tianImgArr,
									universal_sort: this.universal_sort,
									click_str: 'universal'+unive_i+l,
								}
							}
							unive_i++
							this.testForm_universal.push(obj)
						}
					}
				}
				
				console.log(that.formal);
				// console.log(that.testForm);
				// console.log(that.testForm_universal);

				if(tnum<1 && that.timeTotal){
					that.countDown()
					tnum++
				}
				
				let cal=$(".timeCalculationBox"),
					calTop=cal.offset().top,
					calLeft=cal.offset().left
				$(window).scroll(function(){
					if($(document).scrollTop() > 0){
						cal.addClass("pfx").css({
							top:calTop,
							left:calLeft-3
						})
					}else{
						cal.removeClass("pfx").removeAttr("style");
					}
				})
			}else{
				that.$alert(resData.message, '提示', {
					confirmButtonText: '确定',
					closeOnHashChange: false,
					showClose: false,
					callback: action => {
						that.tijiaolikai=true
						that.back_courseInfo()
					}
				});
			}
		})
	}
	,methods:{
		handProgress(key, ti_index){
			// console.log('点击添加文件');
			this.upload_img_info = {
				key:key,
				ti_index:ti_index
			}
		},
		handle_change(file, fileList){
			// console.log('文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用');
			// console.log(file, fileList)
			let that = this
				,test_id = this.$route.query.test_id
				,del_file = false
				,key = this.upload_img_info.key
				,ti_index = this.upload_img_info.ti_index
			if(file.raw.type != "image/jpg" && file.raw.type != "image/jpeg" && file.raw.type != "image/png"){
				this.$alert('只能上传jpg/jpeg/png文件', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			if(file.size > 512000){
				this.$alert('图片大小不能超过500KB', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			//验证不通过，删除显示的文件
			if(del_file){
				fileList.splice(fileList.length-1, 1)
			}else{
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				//验证通过，上传图片
				let upload_path = `xuexi.qsxueli.com/uploadFile/question_bank/${test_id}/${that.$md5(new Date().getTime().toString())}.${file.raw.type.split("/")[1]}`;
				this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/question_bank/'+test_id}))
		    	.then(res=>{
					let resData = res.data
					if(resData.code==0){
						let oss_data = new FormData()
						oss_data.append("key",upload_path);
 						oss_data.append("policy", resData.data.policy);
 						oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 						oss_data.append("success_action_status", '200');
 						oss_data.append("signature", resData.data.signature);
 						oss_data.append("file", file.raw);
						
						this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
							// console.log(res);
							if (res.ok) {
								that.testForm[key][ti_index].answer_img.push({
									uid:file.uid
									,url:that.global.oss_link + upload_path
									,name:upload_path
									,file_name:file.name
								})
							}else{
								that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
									confirmButtonText: '确定',
								});
								fileList.splice(fileList.length-1, 1)
							}
						})
					}else{
						that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
							confirmButtonText: '确定',
						});
						fileList.splice(fileList.length-1, 1)
						this.$message.error(resData.message)
					}
					loading.close()
		    	}).catch(_ => {
					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
						confirmButtonText: '确定',
					});
					fileList.splice(fileList.length-1, 1)
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
					loading.close()
				});
			}
		},
		u_handle_change(file, fileList){
			// console.log('文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用');
			// console.log(file, fileList)
			let that = this
				,test_id = this.$route.query.test_id
				,del_file = false
				,key = this.upload_img_info.key
				,ti_index = this.upload_img_info.ti_index
			if(file.raw.type != "image/jpg" && file.raw.type != "image/jpeg" && file.raw.type != "image/png"){
				this.$alert('只能上传jpg/jpeg/png文件', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			if(file.size > 512000){
				this.$alert('图片大小不能超过500KB', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			//验证不通过，删除显示的文件
			if(del_file){
				fileList.splice(fileList.length-1, 1)
			}else{
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				//验证通过，上传图片
				let upload_path = `xuexi.qsxueli.com/uploadFile/question_bank/${test_id}/${that.$md5(new Date().getTime().toString())}.${file.raw.type.split("/")[1]}`;
				this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/question_bank/'+test_id}))
		    	.then(res=>{
					let resData = res.data
					if(resData.code==0){
						let oss_data = new FormData()
						oss_data.append("key",upload_path);
 						oss_data.append("policy", resData.data.policy);
 						oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 						oss_data.append("success_action_status", '200');
 						oss_data.append("signature", resData.data.signature);
 						oss_data.append("file", file.raw);
						
						this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
							// console.log(res);
							if (res.ok) {
								that.testForm_universal[key][ti_index].answer_img.push({
									uid:file.uid
									,url:that.global.oss_link + upload_path
									,name:upload_path
									,file_name:file.name
								})
							}else{
								that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
									confirmButtonText: '确定',
								});
								fileList.splice(fileList.length-1, 1)
							}
						})
					}else{
						that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
							confirmButtonText: '确定',
						});
						fileList.splice(fileList.length-1, 1)
						this.$message.error(resData.message)
					}
					loading.close()
		    	}).catch(_ => {
					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
						confirmButtonText: '确定',
					});
					fileList.splice(fileList.length-1, 1)
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
					loading.close()
				});
				
				
			}
		},
		handle_exceed(files, fileList){
			// console.log('文件超出个数限制时的钩子');
			this.$alert('最多上传5张图片', '信息提示', {
				confirmButtonText: '确定'
			})
		},
		handleRemove(file, key, ti_index) {
			// console.log('删除了文件');
			let del_idx = -1
				,answer_img = this.testForm[key][ti_index].answer_img
				,that = this
			answer_img.forEach(function(item,index){
				if(item.uid == file.uid){
					del_idx = index
					console.log(item);
					// let del_res = that.client.delete(item.name)
					console.log(del_res);
					// .then((res)=>{
					// 	if(res.res && res.res.statusMessage == "OK"){
					// 	}
					// })
					// .catch((err)=>{
					// 	console.log(err);
					// })
				}
			})
			if(del_idx > -1){
				answer_img.splice(del_idx, 1);
			}
		},
		u_handleRemove(file, key, ti_index) {
			// console.log('删除了文件');
			let del_idx = -1
				,answer_img = this.testForm_universal[key][ti_index].answer_img
				,that = this
			answer_img.forEach(function(item,index){
				if(item.uid == file.uid){
					del_idx = index
					console.log(item);
					// let del_res = that.client.delete(item.name)
				}
			})
			if(del_idx > -1){
				answer_img.splice(del_idx, 1);
			}
		},
		handlePictureCardPreview(file) {
			this.question_preview_visible = true
			this.preview_img_src = file
		},
		//返回到考试页
		back_courseInfo(){
			let router_arr = this.page_location[this.page_location.length-1]
			this.$router.push({
				path: router_arr.router,
				name: router_arr.name,
				query: router_arr.query,
				params: ''
			})
		},
		//点击当前位置的跳转函数
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
		//大标题文字输出
		big_qs_tit_txt(t){
			let c;
			switch (t) {
				case "single":
					c="单选题"
					break;
				case "multiple":
					c="多选题"
					break;
				case "judgement":
					c="判断题"
					break;
				case "fill":
					c="填空题"
					break;
				case "open":
					c="主观题"
					break;
				case "other1":
					c="名词解释题"
					break;
				case "other2":
					c="论述分析题"
					break;
			}
			return c;
		},
		//交卷函数
		done_exercise(){
			this.done_exam_load = true
			let that=this
				,url = serverSrc+qianzui+'/exercises/doExercise'
			
			this.tijiaolikai=true
			let testForm = this.testForm;
			let testForm_universal = this.testForm_universal
			let anArr=[]
			for(var key in testForm){
				if (key!='universal') {
					testForm[key].forEach(function(item,index){
						if(item.answer.length != 0 || item.answer_img.length > 0){
							anArr.push(item)
						}
					})	
				}
			}
			for (let i = 0; i < testForm_universal.length; i++) {
				for (const key in testForm_universal[i]) {
					let item = testForm_universal[i][key]
					if(item.answer.length != 0 || item.answer_img.length > 0){
						anArr.push(item)
					}
				}
				
			}
			this.done_end_time = new Date().getTime()		//练习结束时间
			console.log(anArr);
			// return false
			let total_time = parseInt( (this.done_end_time - this.done_start_time) / 1000)
			//交卷请求
			this.$ajax.post(url,
				this.$qs.stringify({
					answer: anArr,
					use_time: total_time,
					exercise_id: this.$route.query.test_id
				})
			)
			.then(function(res){
				let resData=res.data;
				if(resData.code==0){
					that.done_exam_load=false
					that.$alert('交卷成功！！！', '信息提示', {
						confirmButtonText: '确定',
						callback: action => {
							// 页面切换到计算页
							that.done_exam_result = true
							// 交卷时间输出
							let end_at = resData.data.end_at.split(" ")
								,end_day = end_at[0].split("-")
							that.done_exam = resData.data
							that.done_exam.time = end_day[0]+"年"+end_day[1]+"月"+end_day[2]+"日 " + end_at[1]
							that.done_exam.percentage = (resData.data.sys_score / that.test_fen) * 100		// 得分百分比
							that.done_exam.sys_score = resData.data.sys_score								// 得分
							that.done_exam.wrong_num = resData.data.wrong_num + resData.data.not_done_num	// 答错题目数：答错+未做
							that.done_exam.total_time = that.$selfjs.secondsFormat(total_time, {format:"H小时M分S秒"})
							that.$nextTick(function () {
								$(".el-progress-circle__track").attr("stroke","#fff")		//修改百分比圈的底色
							})
						}
					});
				}else{
					that.$message.error(resData.message);
					that.done_exam_load=false
				}
			})
			.catch(()=>{
				that.$message.error("网络异常");
				that.done_exam_load=false
			})
		},
		//点击提交按钮
		submitForm() {
			// this.$message.error('提交失败');
			// return 
			let that=this
			let ble=true
			// console.log(this.testForm);
			let testForm=this.testForm
			let testForm_universal = this.testForm_universal
			for(let key  in testForm){
				if (key!='universal') {
					if(key!='fill'){
						for(let i = 0;i<testForm[key].length;i++){
							if(testForm[key][i].answer.length==0){
								ble=false
								break;
							}
						}
					}else{
						for(let i = 0;i<testForm[key].length;i++){
							for(let j = 0;j<testForm[key][i].answer.length;j++){
								if(testForm[key][i].answer[j]==''){
									ble=false
									break;
								}
							}

						}
					}	
				}
  			    //   console.log(key + '---' + testForm[key])
  			}
			console.log(testForm_universal);
			for (let i = 0; i < testForm_universal.length; i++) {
				for (const key in testForm_universal[i]) {
					for (let j = 0; j < testForm_universal[i][key].answer.length; j++) {
						if(testForm_universal[i][key].answer[j]==''){
							ble=false
							break;
						}
					}
					
				}
			}
			if(ble){
				this.$confirm('是否交卷?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.done_exercise();
				}).catch(() => {
					//点击取消          
				});
			}else{
				this.$confirm('该试题还没完成，是否继续答题?', '温馨提示', {
					confirmButtonText: '完成交卷',
					cancelButtonText: '继续答卷',
					type: 'warning'
				}).then(() => {
					that.done_exercise(); 
				}).catch(() => {
					//点击取消         
					
				});
			}
			
		},
		//考试倒计时
		countDown() {
			let that = this
			this.global.pageTimer['examTime'] = window.setInterval(() => {
				let s = this.timeTotal-1
				if(s == 0){
					this.timeCal = '0:00:00'
					this.timeTotal = s
					clearTimeout(this.global.pageTimer['examTime'])
					this.$alert('考试时间到，请交卷', '提示', {
						confirmButtonText: '确定',
						closeOnHashChange: false,
						showClose: false,
						callback: action => {
							that.done_exercise();
						}
					});
					return false;
				}
				var hour = Math.floor( s / 3600); 
				var minute = Math.floor( (s - hour*3600) /60 ); 
				var second = s - hour*3600 - minute*60; 
				this.timeCal = hour + ":" + (minute<10?'0'+minute:minute) + ":" + (second<10?'0'+second:second)
				this.timeTotal = s
			},1000)
		},
		//页面滚动
		scrollFn(cla){
			$("html,body").animate({
				scrollTop:$('.'+cla).offset().top-100
			})
		},
		//悬浮框高亮样式
		time_cal_class(obj){
			// return ''
			let cla=''
			if(obj.answer){
				for(var a=0;a<obj.answer.length;a++){
					if(obj.answer[a].length>0){
						cla = 'act'
						break;
					}
				}
				if(obj.answer_img.length>0){
					cla = 'act'
				}
			}
			return cla
		},
		//再测一次
		test_again(){
			this.reload()
		},
		//题目解析
		test_err(type){
			let data = this.$route.query
			data.log_id = this.done_exam.id
			data.result = 0

			if(type == 'error'){
				data.result = '0,2'
			}else if(type == 'all'){
				data.result = ''
			}
			// 跳转到题目解析页
			this.$router.push({
				path: '/web/courseInfo/exercise_err',
				name: 'exercise_err',
				query: data,
				params: ''
			})
		},
		//离开页面函数
		pageout(){
			if(this.leave_type == 'beforeRouteLeave'){
				//执行默认的跳转操作
				this.beforeRouteLeave_next()
			}else if(this.leave_type == 'popstate'){
				this.$message({
					showClose: true,
					message: '再次点击确定将执行返回上一页',
					type: 'warning'
				});
				this.dialogVisible = false
				//点击上一页按钮则返回考试安排列表页
				this.back_courseInfo()
			}
		}
	},
	computed:{
	},
	destroyed:function(){
		clearTimeout(this.global.pageTimer['examTime'])
	},
	//vue切换页面
	beforeRouteLeave(to, form, next){
		if(this.join_kaoshi.switch && !this.tijiaolikai){
			if(!this.dialogVisible){
				this.leave_type = 'beforeRouteLeave'
				this.dialogVisible = true
				history.pushState(null, null, `/web/#/web/courseInfo?courseId=${this.$route.query.courseId}&menuBox=zuoye`);

				this.beforeRouteLeave_next = next	
			}
		}else{
			next();
			// clearTimeout(this.global.pageTimer['examTime'])
		}
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style lang="scss" scoped>
#index{background:#f4f4f4;}
.title{
	display: inline-block;
	max-width: calc(100% - 100px);
    // width: calc(100% - 100px);
    word-wrap: break-word;
}
</style>
<style>
	#test .el-form-item__content .el-textarea__inner{
		resize: vertical;
	}
</style>


// WEBPACK FOOTER //
// src/components/course_info/exercise.vue